module.exports = __webpack_public_path__ + "static/media/logo-paraibano.bcd3b887.png";